import { createRoot } from "react-dom/client";

export type SuggestionReactRoot = ReturnType<typeof createRoot>;

/**
 * TipTap suggestion plugins render outside the React tree. Mount a root on the editor's
 * `ownerDocument.body` (required in Storybook/iframes where `document` is not the iframe).
 * Pair with {@link unmountSuggestionRoot} on exit.
 */
export const mountSuggestionRoot = (
  ownerDocument: Document,
): {
  container: HTMLDivElement;
  root: SuggestionReactRoot;
} => {
  const container = ownerDocument.createElement("div");
  ownerDocument.body.appendChild(container);
  const root = createRoot(container);
  return { container, root };
};

export const unmountSuggestionRoot = (
  container: HTMLDivElement | null,
  root: SuggestionReactRoot | null,
) => {
  if (root != null && container != null) {
    root.unmount();
    container.remove();
  }
};
